import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faUser } from "@fortawesome/free-solid-svg-icons";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Box from "@material-ui/core/Box";
import { usePrizePicksProjections } from "registerations/hooks/prizePicksProjections";
import Cookies from "js-cookie";
import apiService, {login, register, getData} from "lib/api/apiService";
// import axios from "axios";
// import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "relative",
    overflow: "hidden",
  },

  managerBox: {
    overflow: "hidden",
    position: "relative",
    top: "8%",
    left: "50%",
    transform: "translate(-50%, 10%)",
    width: "520px",
    height: "400px",
    padding: "20px",
    borderRadius: "40px",
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 4px 30px -5px rgba(0,0,0,0.65)",

    "& .App": {
      background: "#fff",
      height: "400px",
      width: "520px",
      borderRadius: "5px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",

      "& .input-container": {
        position: "relative",
        marginBottom: "30px",
        width: "340px",

        "& input": {
          fontFamily: "'Dosis', sans-serif",
          letterSpacing: "1.3px",
          boxSizing: "border-box",
          background: "transparent",
          width: "100%",
          border: "none",
          borderBottom: "1px solid #27282d",
          color: "#4d4343",
          padding: "12px 6px 12px 40px",
          fontSize: "19px",
          outline: "none",
          caretColor: "rgb(229, 91, 141)",
        },

        "& input:focus": {
          borderBottom: "1px solid transparent",
          borderImage:
            "linear-gradient(140deg, rgb(219, 98, 65) 0%, rgb(229, 91, 141) 100%)",
          borderImageSlice: "1",
          color: "#4d4343",
        },

        "& input::placeholder": {
          color: "#363030",
          opacity: ".3",
        },
      },

      "& .confirmbtn": {
        background: "lighten(#27282d, 5%)",
        border: "none",
        borderRadius: "30px",
        color: "lighten(#27282d, 85%)",
        fontSize: "16px",
        padding: "16px 36px",
        cursor: "pointer",
        transition: "all .3s",
        marginTop: "20px",
        marginBottom: "-30px",
        boxShadow: "0px 4px 15px -5px rgba(0,0,0,0.65)",
      },

      "& .confirmbtn:hover": {
        background: "lighten(#27282d, 10%)",
        boxShadow: "0px 5px 20px -3px rgba(0,0,0,0.65)",
      },
    },

    "& @media screen and (max-width: 620px)": {
      "& .App": {
        minHeight: "300px",
        maxHeight: "420px",
        width: "90vw",

        "& .input-container": {
          width: "80%",
          marginBottom: "40px",
        },

        "& button": {
          marginTop: "10px",
          marginBottom: "-20px",
        },
      },
    },
  },
}));

export const UserModal: React.FC = () => {
  const classes = useStyles();


  const [username, setUsername] = React.useState("")
  const [password, setPassword] = React.useState("")

  const { fetchProjectionsData } = usePrizePicksProjections();


  const [registerError, setRegisterError] = React.useState(false);
  const [message, setMessage] = React.useState('');

  const errorClose = () => {
    setRegisterError(false);
  };

  const errorOpen = () => {
    setRegisterError(true);
  };


  const [registerConfirmation, setRegisterConfirmation] = React.useState(false);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !(!username || !password)) {
      confirmOpen();
    }
  };


  const confirmOpen = async () => {

      try {
        const token = await login(username, password);
        Cookies.set('token', token, { expires: 7, sameSite: 'strict' });
        setRegisterConfirmation(true)
        fetchProjectionsData()
        window.location.href = "/home";
  
      } catch (error) {
        setMessage('Login failed. Check your credentials.');
        setRegisterError(true)
      }


  

  };
  const confirmClose = () => {
    setRegisterConfirmation(false);
  };

  return (
    <Box className={classes.managerBox}>
      <div className="App">
        <h1
          style={{
            marginBottom: "55px",
            fontSize: "35px",
            color: "#f22b0c",
          }}
        >
          Login
        </h1>
        <div className="input-container">
          <input
            type="text"
            placeholder="Username"
            name="username"
            value={username}
            onChange={(e:any)=>{
              setUsername(e.target.value)
            }}
          />
          <FontAwesomeIcon
            icon={faUser}
            size="lg"
            style={{
              color: "#363030",
              position: "absolute",
              left: "6px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />
        </div>

        <div className="input-container">
          <input
            type="password"
            placeholder="Password"
            name="password"
            value={password}
            onChange={(e:any)=>{
              setPassword(e.target.value)
            }}
            onKeyDown={handleKeyPress}
          />
          <FontAwesomeIcon
            icon={faLock}
            size="lg"
            style={{
              color: "#363030",
              position: "absolute",
              left: "6px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />
        </div>
        <button
          className="confirmbtn"
          type="submit"
          onClick={confirmOpen}
          disabled={
            !username || !password
          }
        >
          Log in
        </button>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
          open={registerConfirmation}
          onClose={confirmClose}
        >
          <Alert onClose={confirmClose} variant="filled" severity="success">
            <p style={{ fontSize: "14px" }}>Login Successful</p>
          </Alert>
        </Snackbar>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
          open={registerError}
          onClose={errorClose}
        >
          <Alert onClose={confirmClose} variant="filled" severity="error">
            <p style={{ fontSize: "14px" }}>
              {message}
            </p>
          </Alert>
        </Snackbar>
      </div>
    </Box>
  );
};
